module.exports = __webpack_public_path__ + "img/38.3f3d6890.jpg";